import { Icon, InfoLabel, Tooltip } from '@jutro/components';
import { Grid } from '@jutro/layout';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext, useAuthentication } from '@xengage/gw-digital-auth-react';
import { JobUtil } from '@xengage/gw-portals-util-js';
import classNames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import React, { useState, useCallback } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import NotesComponent from 'gw-capability-gateway-react/Components/NotesComponent/NotesComponent';
import ReassignActivity from 'gw-capability-gateway-react/Components/Activity/ReassignActivityComponent/ReassignActivity';
import { ActivitiesService } from 'gw-capability-gateway';
import { Button } from '@jutro/legacy/components';
import ENTDdocumentUploadComponent from 'gw-capability-gateway-react/Components/ENTDocumentUpload/ENTDocumentUploadComponent';
import { Link } from '@jutro/router';
import messages from './ActivityTableComponent.messages';
import metadata from './ActivityTableComponent.metadata.json5';
import styles from './ActivityTableComponent.module.scss';

const ActivityTableComponent = props => {
    const {
        activitiesOverdue,
        activitiesToday,
        activitiesTomorrow,
        activitiesThisWeek,
        activitiesComplete,
        displayNoActivities,
        activitiesFuture,
        createNote,
        onClickComplete,
        publicId,
        hideCompleteButton,
    } = props;
    const translator = useTranslator();

    const [selectedActivity, setSelectedActivity] = useState();
    const [isActUnassigned, setIsActUnassigned] =  useState(selectedActivity?.status !== 'unassigned')
    const authHeader = _.get(useAuthentication(), 'authHeader');

    const dateFormat = date => {
        const newdate = moment(date).toDate();

        return moment(newdate).format('MM/DD/YYYY');
    };


    const getPriority = (data, rowID) => {
        let priorityType = '';

        switch (data.priority) {
            case 'high':
                priorityType = 'warning';
                break;
            case 'normal':
                priorityType = 'success';
                break;
            case 'urgent':
                priorityType = 'error';
                break;
            case 'low':
                priorityType = 'neutral';
                break;
            default:
                break;
        }
        
        return (
            <div>
                <Tooltip
                    placement="bottom"
                    content={data.priorityDesc}
                    id={`PriorityTooltip${rowID}`}
                >
                    <span>
                        <InfoLabel
                            type={priorityType}
                            size="small"
                            id={`PriorityLabel${rowID}`}
                            message={translator({
                                id: `typekey.Priority.${data.priority}`,
                                defaultMessage: data.priority,
                            })}
                        />
                    </span>
                </Tooltip>
            </div>
        );
    };

    const getNotes = data => (
            <div>
                {data.notes.length}
                <Icon
                    tag="span"
                    className={styles.activityIcon}
                    icon="mi-note"
                />
            </div>
        );

    const getNoOfDueDays = data => {
        let dueDaysColumn = '';

        if (
            data.status === 'complete' ||
            data.dueDate === null ||
            data.dueDate === undefined
        ) {
            dueDaysColumn = '-';
        } else {
          
            // As per requirement , it is asked to show date not day, so commenting out OOTB code
            dueDaysColumn = dateFormat(data.dueDate);  // dateFormat(data.dueDate);  
        }

        return dueDaysColumn;
    };

    const onJobClicked = data => {
        let redirectPath = '';

        if (data.productName && data.policyNumber && !data.jobNumber) {
            const policyUrl = `/policies/${data.policyNumber}/summary`;

            redirectPath = (
                <RouterLink
                    className={styles.removeLinkStyle}
                    title={data.productName}
                    to={policyUrl}
                >
                    {data.policyNumber}
                </RouterLink>
            );
        } else if (
            data.productName &&
            data.jobNumber &&
            !JobUtil.isSupportJobType(data.jobType)
        ) {
            redirectPath = (
                <Link
                    href="/"
                    className={styles.removeLinkStyle}
                    title={data.productName}
                    onClick={() => JobUtil.openJobInXCenter(data.jobNumber)}
                >
                    {data.jobNumber}
                </Link>
            );
        } else {
            if (data?.jobType === 'Renewal' && data?.uwcompany_TWIA === 'tfpa') { // DE18525
                return (
                    <RouterLink
                        to={`/policy-job-details/${data.jobNumber}`}
                        className={styles.removeLinkStyle}
                        title={data.jobNumber}
                    >
                        {data.jobNumber}
                    </RouterLink>
                )
            }
            
            redirectPath = (
                <RouterLink
                    className={styles.removeLinkStyle}
                    title={data.productName}
                    to={JobUtil.getJobDetailURLByJobType(
                        data.jobType,
                        data.jobNumber
                    )}
                >
                    {data.jobNumber}
                </RouterLink>
            );
        }

        return redirectPath;
    };

    const getSubject = data => {
        const redirectRoute = 'summary';
        let subjectData = '';
        const text = translator(messages.for);

        // DE18525
        if (data.productName !== undefined && data.productName !== null) {
            subjectData = (
                <div style={{ whiteSpace: 'normal' }}>
                    {`${data.subject} ${text} `}
                    {onJobClicked(data)}
                    {` ${text} `}
                    <RouterLink
                        to={`/accounts/${data.accountNumber}/${redirectRoute}`}
                        className={styles.removeLinkStyle}
                        title={data.accountHolderName}
                    >
                        {data.accountHolderName}
                    </RouterLink>
                </div>
            );
        } else {
            subjectData = (
                <div style={{ whiteSpace: 'normal' }}>
                    {`${data.subject} ${text} `}
                    <RouterLink
                        to={`/accounts/${data.accountNumber}/${redirectRoute}`}
                        className={styles.removeLinkStyle}
                        title={data.accountHolderName}
                    >
                        {data.accountHolderName}
                    </RouterLink>
                </div>
            );
        }

        return subjectData;
    };

    const expanderContent = data => {

        const description = _.get(data, 'description', '-');

        const getEscalationDate = !_.isUndefined(data.escalationDate)
            ? dateFormat(data.escalationDate)
            : '-';

        setSelectedActivity(data);

        return (
            <div className={styles.gwActivityContent}>
                <Grid
                    columns={['0.25fr', '0.75fr', '0.25fr', '1fr']}
                    rows={['1fr', '1fr']}
                    gap="large"
                    className={styles.gwActivityTableRowDescription}
                >
                    <div className={styles.field}>
                        {translator(messages.escalationDate)}
                    </div>
                    <div className={styles.fieldValue}>{getEscalationDate}</div>
                    <div className={styles.field}>
                        {translator(messages.createdBy)}
                    </div>
                    <div className={styles.fieldValue}>{data.createdBy}</div>
                    <div className={styles.field}>
                        {translator(messages.aType)}
                    </div>
                    <div className={styles.fieldValue}>{data.subject}</div>
                    <div className={styles.field}>
                        {translator(messages.created)}
                    </div>
                    <div className={styles.fieldValue}>
                        {dateFormat(data.createdDate)}
                    </div>
                    <div className={styles.field}>
                        {translator(messages.description)}
                    </div>
                    <div className={styles.fieldValue}>{description}</div>
                </Grid>
                <div className={styles.gwActivityTableNotesSeparator}>
                    <NotesComponent
                        initialNotesData={data.notes}
                        createNote={createNote}
                        publicID={data.publicID}
                        openActivitiesNote
                        showNoteButton={!data.closeDate}
                    />
                </div> 
                <div><ENTDdocumentUploadComponent
                        productCode={data.productName}
                        uwCompany={data.uwcompany_TWIA}
                        jobNumber={data.jobNumber}
                        policyNumber={data.policyNumber}
                        activityPublicID={data.publicID}
                        locations={data.locations_TWIA}
                        disableUpload = {['complete', 'unassigned'].includes(data.status)}
                     /></div>
            </div>
        );
    };

    const getAssignedActivity = item => {
        const reAssignActivity = activity => {
            _.merge(item, activity);
            setSelectedActivity(activity);
            setIsActUnassigned(activity?.status !== 'unassigned');
        };

        return (
            <ReassignActivity
                activity={item}
                onUpdateActivity={reAssignActivity}
            />
        );
    };

    const completeButton = useCallback(
        item => {

            setSelectedActivity(item);

            let completedButton;
            const checkExpanded = classNames({
                [styles.gwShowCompleteButton]: item.expanded  && item.status !== 'unassigned',
                [styles.gwHideCompleteButton]: !item.expanded && item.status === 'unassigned',
            });

            if (item.canComplete) {
                completedButton = (
                    <div key={item.publicID}>
                        <Button
                            className={checkExpanded}
                            onClick={() => onClickComplete(item.publicID)}
                            icon="mi-check"
                        >
                            {translator(messages.complete)}
                        </Button>
                    </div>
                );
            } else if (item.status === 'complete') {
                completedButton = (
                    <div>
                        <Icon
                            tag="span"
                            icon="mi-check"
                            className={styles.activityIcon}
                        />
                        {translator(messages.completed)}
                    </div>
                );
            } else {
                completedButton = null;
            }

            if (item.publicID === publicId) {
                return (
                    <div>
                        <Icon
                            tag="span"
                            icon="mi-check"
                            className={styles.activityIcon}
                        />
                        {translator(messages.completed)}
                    </div>
                );
            }
            
            return completedButton;
        },
        [publicId, translator, onClickComplete]
    );

    const overrideProps = {
        activitiesFutureTableHeader: {
            visible: activitiesFuture.length > 0
        },
        activitiesFutureTable: {
            data: activitiesFuture,
            renderExpanderContent: expanderContent,
            visible: activitiesFuture.length > 0,
        },
        activitiesTodayTableHeader: {
            visible: activitiesToday.length > 0
        },
        activitiesTodayTable: {
            data: activitiesToday,
            renderExpanderContent: expanderContent,
            visible: activitiesToday.length > 0,
        },
        activitiesTomorrowTableHeader: {
            visible: activitiesTomorrow.length > 0
        },
        activitiesTomorrowTable: {
            data: activitiesTomorrow,
            renderExpanderContent: expanderContent,
            visible: activitiesTomorrow.length > 0,
        },
        activitiesThisWeekTableHeader: {
            visible: activitiesThisWeek.length > 0
        },
        activitiesThisWeekTable: {
            data: activitiesThisWeek,
            renderExpanderContent: expanderContent,
            visible: activitiesThisWeek.length > 0,
        },
        activitiesOverdueTableHeader:{
            visible: activitiesOverdue.length > 0
        },
        activitiesOverdueTable: {
            data: activitiesOverdue,
            renderExpanderContent: expanderContent,
            visible: activitiesOverdue.length > 0,
        },
        activitiesCompleteTableHeader:{
            visible: activitiesComplete.length > 0
        },
        activitiesCompleteTable: {
            data: activitiesComplete,
            visible: activitiesComplete.length > 0,
            renderExpanderContent: expanderContent,
        },
        noActivityFound: {
            visible: displayNoActivities !== false,
        },
        noActivitySeparator: {
            visible: displayNoActivities !== false,
        },
        activitiesDetailGrid: {
            visible: displayNoActivities === false,
        },
        completeButtonSection: {
            disable: hideCompleteButton && isActUnassigned
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getNoOfDueDays,
            getSubject,
            getNotes,
            getPriority,
            completeButton,
            getAssignedActivity,
            onRowClick: async data => {
                _.set(data, 'expanded', !data.expanded);
                setSelectedActivity(data);

                if(_.isEmpty(data.assignableUsers) && _.isNull(data.assignableUsers)){
                    const response = await ActivitiesService.getAssignableUsers_TWIA(data.publicID, authHeader);
                    
                    _.set(data, 'assignableUsers', response);
                }
                    
            },
        },
    };

    const openActivityPage = (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers}
        />
    );

    return <div className={classNames(styles.summary)}>{openActivityPage}</div>;
};

ActivityTableComponent.propTypes = {
    activitiesOverdue: PropTypes.arrayOf(PropTypes.shape({})),
    activitiesFuture: PropTypes.arrayOf(PropTypes.shape({})),
    activitiesTomorrow: PropTypes.arrayOf(PropTypes.shape({})),
    activitiesThisWeek: PropTypes.arrayOf(PropTypes.shape({})),
    activitiesToday: PropTypes.arrayOf(PropTypes.shape({})),
    activitiesComplete: PropTypes.arrayOf(PropTypes.shape({})),
    onClickComplete: PropTypes.func.isRequired,
    createNote: PropTypes.func.isRequired,
    displayNoActivities: PropTypes.bool.isRequired,
    publicId: PropTypes.string,
};
ActivityTableComponent.defaultProps = {
    activitiesTomorrow: [],
    activitiesFuture: [],
    activitiesOverdue: [],
    activitiesComplete: [],
    activitiesThisWeek: [],
};
export default withAuthenticationContext(ActivityTableComponent);
